import React from 'react';

import styles from './CollectionList.scss';
import CollectionListItem from 'Components/CollectionListItem';
import ClassesListItem from 'Containers/ClassesListItem';
import SchoolsListItem from 'Containers/SchoolsListItem';

const getListItem = (item, type, i) => {
  switch (type) {
    case 'classes':
      return <ClassesListItem key={i} type={type} {...item} />;
      break;
    case 'schools':
      return <SchoolsListItem key={i} type={type} {...item} />;
      break;
    default:
      return <CollectionListItem key={i} type={type} {...item} />;
  }
};

const CollectionList = ({ items, type }) => {
  return (
    <div className="CollectionList">
      <div className="CollectionList__container">
        <div className="CollectionList__items">
          {items.map((item, i) => getListItem(item, type, i))}
        </div>
      </div>
    </div>
  );
};

export default CollectionList;
